export const container = `
  group/sidebar flex flex-col z-10
  bg-base-white rounded
  overflow-hidden max-h-[calc(100vh-72px)] min-h-96
  absolute top-3  left-3
  w-full max-w-72 shadow-3sm
  transition-all duration-150 ease-in-out

  data-[is-expanded=false]:w-14

  hover:data-[is-expanded=false]:w-16
  hover:data-[is-expanded=false]:cursor-pointer
`;
